"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@mui/material/styles"),i=e.styled("div")`
  height: ${({heightCSS:t})=>t||"100vh"};
`,n=e.styled("div")`
  display: flex;
  flex-direction: column;
`,a=e.styled("div")`
  display: flex;
  gap: ${({theme:t})=>t.spacing(1)};
  margin: ${({theme:t})=>t.spacing(1)};
`;exports.ButtonWrapper=a;exports.PatientTodayList=n;exports.PatientTodayListContainer=i;
